import type { EventScheduleRow } from "~produce/production/schedule/events/helpers/eventScheduleGrid";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface EventScheduleState {
	detailActiveTab: number;
	selectedRow?: EventScheduleRow;
}

const initialState: EventScheduleState = {
	detailActiveTab: 0
};

const eventScheduleSlice = createSlice({
	initialState,
	name: "eventSchedule",
	reducers: {
		setEventScheduleDetailActiveTab: (state, action: PayloadAction<number>) => {
			state.detailActiveTab = action.payload;
		},
		setSelectedEventScheduleRow: (state, action: PayloadAction<EventScheduleRow | undefined>) => {
			state.selectedRow = action.payload;
			state.detailActiveTab = 0;
		}
	}
});

export const { setEventScheduleDetailActiveTab, setSelectedEventScheduleRow } = eventScheduleSlice.actions;

export default eventScheduleSlice.reducer;
